import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router } from "@angular/router";

import { BaseService } from "./base.service";
import { Tag } from "../models/tag.model";

@Injectable()
export class TagService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getTags(): Promise<Array<Tag>> {
    return this.get("tags");
  }

  async getTagsForData(dataType: string, dataId: any): Promise<Array<Tag>> {
    return this.get("tags/" + dataType + "/" + dataId);
  }

  async getImageTagsByPatient(patientId: string): Promise<Array<Tag>> {
    return this.get("imageTags/" + patientId);
  }

  async getPatientTagsByImage(imageId: string): Promise<Array<Tag>> {
    return this.get("patientTags/" + imageId);
  }

  async attachTag(payload: {
    tagId: number;
    dataId: string;
    dataTypeId: number;
  }) {
    return this.post("attachTag", payload);
  }

  async detachTag(payload: {
    tagId: number;
    dataId: string;
    dataTypeId: number;
  }) {
    return this.post("detachTag", payload);
  }

  async adminGetTags(): Promise<Array<Tag>> {
    return this.get("admin/tag");
  }

  async adminCreateTag(tag: Tag): Promise<null> {
    return this.post("admin/tag", tag);
  }

  async adminDeleteTag(tagId: number): Promise<null> {
    return this.delete("admin/tag/" + tagId);
  }

  async adminUpdateTag(tagId: number, tag: Tag): Promise<null> {
    return this.post("admin/tag/" + tagId, tag);
  }

  async getTagsForPatients(patientIds: string[]): Promise<Tag[]> {
    return this.post("tags/patients", { patientIds: patientIds });
  }

  async bulkAddTags(tagId: number, patientIds: string[]): Promise<null> {
    return this.post("tags/bulkAdd", { tagId: tagId, patientIds: patientIds });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tag.service.ts